import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface InvoiceListActionsHeaderProps
  extends HeaderContext<InvoiceModel, unknown> {}

export const InvoiceListActionsHeader =
  (): // props: InvoiceListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
